import {Component, OnDestroy, OnInit} from '@angular/core';
import { ModuleService } from "../../Services/module.service";
import {Observable, Subject} from "rxjs";
import { FieldService } from "./fields/field.service";
import { ActivatedRoute, RouterLinkActive, RouterLink, RouterOutlet } from '@angular/router';
import {Field} from '../../Models';
import {takeUntil} from "rxjs/operators";
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { RouteFilterComponent } from '../../../../../Common/route-filter/route-filter.component';

@Component({
    selector: 'aw-step',
    templateUrl: './step.component.html',
    styleUrls: ['./step.component.less'],
    imports: [MatTabNav, RouterLinkActive, MatTabLink, RouterLink, RouteFilterComponent, MatTabNavPanel, RouterOutlet]
})
export class StepComponent implements OnInit, OnDestroy {
    selectedStepId: string = "";
    environmentalIndicatorDetailStep: string = 'EnvironmentalIndicatorDetail';
    drivingFields$: Observable<Field[]>;
    hasDrivingFields: boolean;
    hasPrimaryFields: boolean;
    componentDestroyed: Subject<void> = new Subject<void>();

    constructor(
        private moduleService: ModuleService,
        private fieldService: FieldService,
        private route: ActivatedRoute,
    ) { }

    ngOnInit() {
        this.route.data.pipe(takeUntil(this.componentDestroyed)).subscribe(data => {
            let stepData = data.stepData;
            this.selectedStepId = stepData.selectedStepId;
            this.hasDrivingFields = stepData.hasDrivingFields;
            this.hasPrimaryFields = stepData.hasPrimaryFields;    
        });
    }

    showSubmissionTypeConfigTab(): boolean {
        return this.selectedStepId === this.environmentalIndicatorDetailStep;
    }

    ngOnDestroy(): void {
        this.componentDestroyed.next();
    }
}
